import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { DefaultEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";

export class TrainListLoadMoreAction extends BaseAction<void, { visibleTrains: number  }> {

    override async run(): Promise<void | null> {
        try {
            const { visibleTrains } = this.params!;
            updateRecoilState("visibleTrainsAtom", (visibleTrains + DefaultEnum.defaultIncrementTrainLoadMore))
        } catch (error) {
            console.error("Error in TrainListLoadMoreAction:", error);
        }
    }
}

// Create a singleton instance
export const trainListLoadMoreAction = new TrainListLoadMoreAction(); 